<template>
  <div id="show-job-form">
    <el-form :model="ruleForm" ref="form" label-width="95px" size="small">
      <el-form-item label="流程节点">
        <el-select v-model="nodeName" class="node-name">
          <el-option
            v-for="(item, index) in node"
            :key="index"
            :label="item.jobName"
            :value="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Task状态" v-if="node[nodeName]">
        <div :class="node[nodeName].status">{{ node[nodeName].status }}</div>
      </el-form-item>
      <el-form-item label="开始时间" v-if="node[nodeName]">
        <div>{{ node[nodeName].startTime }}</div>
      </el-form-item>
      <el-form-item label="结束时间" v-if="node[nodeName]">
        <div>{{ node[nodeName].endTime }}</div>
      </el-form-item>
    </el-form>
    <el-tabs
      class="job-tabs"
      v-model="activeName"
      v-if="node[nodeName]"
      type="card"
    >
      <el-tab-pane label="输入参数" name="canshu-in">
        <el-table
          border
          :show-header="false"
          :data="format(node[nodeName].params)"
          height="100%"
        >
          <el-table-column label="key" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="value" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row[1] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="输出参数" name="canshu-out">
        <el-table
          border
          :show-header="false"
          :data="format(node[nodeName].outParams)"
          height="100%"
        >
          <el-table-column label="key" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="value" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row[1] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "show-job-form",
  props: {
    node: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nodeName: "",
      ruleForm: {
        status: "",
        startTime: "",
        endTime: ""
      },
      showNode: {},
      activeName: "canshu-in"
    };
  },
  watch: {
    node(v) {
      if (v.length && this.nodeName === "") {
        this.nodeName = v.length - 1;
      }
    }
  },
  methods: {
    format(v) {
      if (!v) return [];
      return Object.entries(v);
    }
  }
};
</script>

<style lang="scss">
#show-job-form {
  overflow: auto;
  height: calc(100% - var(--padding) * 2);
  margin: var(--padding);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .node-name {
    width: 100%;
  }
  .job-tabs {
    flex: 1 1 auto;
    overflow: hidden;
  }
  .FAILED,
  .KILLED {
    color: var(--red);
  }
  .SUCCEEDED {
    color: var(--green);
  }
  .RUNNING {
    color: var(--blue);
  }
}
</style>
